module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "_pdv-48px"
  }, [_vm._m(0), _vm._v(" "), _c('p', {
    staticClass: "_mgbt-5px _fs-5"
  }, [_vm._v("\n        เป็น Atomic Class ที่ใช้จัดการ Margin ประกอบด้วย\n      ")]), _vm._v(" "), _vm._m(1), _vm._v(" "), _vm._m(2), _vm._v(" "), _vm._m(3), _vm._v(" "), _vm._m(4), _vm._v(" "), _vm._m(5), _vm._v(" "), _vm._m(6), _vm._v(" "), _vm._m(7), _vm._v(" "), _vm._m(8), _vm._v(" "), _vm._m(9), _vm._v(" "), _vm._m(10), _vm._v(" "), _vm._m(11), _vm._v(" "), _c('hr', {
    staticClass: "_opct-30 _mgbt-32px"
  }), _vm._v(" "), _c('div', {
    staticClass: "_dp-f _jtfct-spbtw"
  }, [_c('div', [_c('h5', {
    staticClass: "_mgbt-16px"
  }, [_vm._v("ก่อนหน้า")]), _vm._v(" "), _c('router-link', {
    staticClass: "bio-link -fancy _pd-8px _bdrd-2px _fs-5",
    attrs: {
      "to": {
        name: 'AtomicFloat'
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-long-arrow-left _fs-5"
  }), _vm._v("  Float\n          ")])], 1), _vm._v(" "), _c('div', [_c('h5', {
    staticClass: "_mgbt-16px _tal-r"
  }, [_vm._v("ต่อไป")]), _vm._v(" "), _c('router-link', {
    staticClass: "bio-link -fancy _pd-8px _bdrd-2px _fs-5",
    attrs: {
      "to": {
        name: 'AtomicObjectFit'
      }
    }
  }, [_vm._v("\n            Object Fit   "), _c('i', {
    staticClass: "fa fa-long-arrow-right _fs-5"
  })])], 1)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "_fs-2 _fw-600 _lh-150pct _mgbt-16px"
  }, [_c('a', {
    staticClass: "bio-link -primary",
    attrs: {
      "href": "#atomic-margin"
    }
  }, [_c('strong', [_vm._v("#")])]), _vm._v(" Margin\n      ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "_mgbt-64px _fs-5 _lh-175pct _pdl-16px"
  }, [_c('li', [_vm._v("• Margin")]), _vm._v(" "), _c('li', [_vm._v("• Margin Left")]), _vm._v(" "), _c('li', [_vm._v("• Margin Right")]), _vm._v(" "), _c('li', [_vm._v("• Margin Top")]), _vm._v(" "), _c('li', [_vm._v("• Margin Bottom")]), _vm._v(" "), _c('li', [_vm._v("• Margin Vertical")]), _vm._v(" "), _c('li', [_vm._v("• Margin Horizontal")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "_mgbt-4px _fs-5"
  }, [_c('strong', [_vm._v("Class Name")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "_mgbt-32px _fs-5 _lh-175pct _pdl-16px"
  }, [_c('li', [_vm._v("• "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("_mg-*")]), _vm._v(" สำหรับ "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("margin")])]), _vm._v(" "), _c('li', [_vm._v("• "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("_mgl-*")]), _vm._v(" สำหรับ "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("margin-left")])]), _vm._v(" "), _c('li', [_vm._v("• "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("_mgr-*")]), _vm._v(" สำหรับ "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("margin-right")])]), _vm._v(" "), _c('li', [_vm._v("• "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("_mgt-*")]), _vm._v(" สำหรับ "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("margin-top")])]), _vm._v(" "), _c('li', [_vm._v("• "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("_mgbt-*")]), _vm._v(" สำหรับ "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("margin-bottom")])]), _vm._v(" "), _c('li', [_vm._v("• "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("_mgv-*")]), _vm._v(" สำหรับ "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("margin-top")]), _vm._v(" และ "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("margin-bottom")]), _vm._v(" (Vertical)")]), _vm._v(" "), _c('li', [_vm._v("• "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("_mgh-*")]), _vm._v(" สำหรับ "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("margin-left")]), _vm._v(" และ "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("margin-right")]), _vm._v(" (Horizontal)")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "_mgbt-16px _fs-5"
  }, [_c('strong', [_vm._v("Value")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', {
    staticClass: "bio-table _mgbt-32px"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "_w-1px"
  }, [_vm._v("Class")]), _vm._v(" "), _c('th', [_vm._v("Value")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_c('p', [_c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("_mg-*")]), _vm._v(",\n                "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("_mgl-*")]), _vm._v(",\n                "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("_mgr-*")]), _vm._v(",\n                "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("_mgt-*")]), _vm._v(",\n                "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("_mgbt-*")]), _vm._v(",\n                "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("_mgv-*")]), _vm._v(",\n                "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("_mgh-*")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "_mgbt-32px"
  }, [_c('strong', [_vm._v("Pixel Value: ")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("0px")]), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("1px")]), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("2px")]), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("4px")]), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("8px")]), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("12px")]), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("16px")]), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("24px")]), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("32px")]), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("48px")]), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("64px")]), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("128px")]), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("256px")]), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("512px")])]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Keyword Value: ")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("at")]), _vm._v(" สำหรับ \"auto\"\n              ")])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "_mgbt-4px _fs-5"
  }, [_c('strong', [_vm._v("Responsive:")]), _vm._v(" "), _c('span', {
    staticClass: "_cl-positive"
  }, [_c('strong', [_vm._v("Yes")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "_mgbt-32px _fs-5 _lh-175pct _pdl-16px"
  }, [_c('li', [_vm._v("• "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("*-sm")])]), _vm._v(" "), _c('li', [_vm._v("• "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("*-md")])]), _vm._v(" "), _c('li', [_vm._v("• "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("*-lg")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "_mgbt-64px _fs-5"
  }, [_c('strong', [_vm._v("Hover:")]), _vm._v(" "), _c('span', {
    staticClass: "_cl-negative"
  }, [_c('strong', [_vm._v("No")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "_mgbt-8px _fs-5"
  }, [_c('strong', [_vm._v("ตัวอย่างการใช้งาน Margin")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('pre', {
    staticClass: "example"
  }, [_c('code', {
    staticClass: "language-markup"
  }, [_vm._v("<!-- Margin -->\n<div class=\"_mg-1px\"></div>\n<div class=\"_mg-2px\"></div>\n<div class=\"_mg-4px\"></div>\n<div class=\"_mg-8px\"></div>\n<div class=\"_mg-16px\"></div>\n\n<!-- Margin Left -->\n<div class=\"_mgl-1px\"></div>\n<div class=\"_mgl-2px\"></div>\n<div class=\"_mgl-4px\"></div>\n<div class=\"_mgl-8px\"></div>\n<div class=\"_mgl-16px\"></div>\n\n<!-- Margin Right -->\n<div class=\"_mgr-1px\"></div>\n<div class=\"_mgr-2px\"></div>\n<div class=\"_mgr-4px\"></div>\n<div class=\"_mgr-8px\"></div>\n<div class=\"_mgr-16px\"></div>\n\n<!-- Margin Vertical -->\n<div class=\"_mgv-1px\"></div>\n<div class=\"_mgv-2px\"></div>\n<div class=\"_mgv-4px\"></div>\n<div class=\"_mgv-8px\"></div>\n<div class=\"_mgv-16px\"></div>\n\n<!-- Margin Horizontal -->\n<div class=\"_mgh-1px\"></div>\n<div class=\"_mgh-2px\"></div>\n<div class=\"_mgh-4px\"></div>\n<div class=\"_mgh-8px\"></div>\n<div class=\"_mgh-16px\"></div>")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "u-panel _mgbt-64px"
  }, [_c('div', {
    staticClass: "_bgcl-neutral-300 _mgbt-4px"
  }, [_c('div', {
    staticClass: "_bgcl-warning _dp-ilb _mg-1px"
  }, [_c('small', [_vm._v("_mg-1px")])])]), _vm._v(" "), _c('div', {
    staticClass: "_bgcl-neutral-300 _mgbt-4px"
  }, [_c('div', {
    staticClass: "_bgcl-warning _dp-ilb _mg-2px"
  }, [_c('small', [_vm._v("_mg-2px")])])]), _vm._v(" "), _c('div', {
    staticClass: "_bgcl-neutral-300 _mgbt-4px"
  }, [_c('div', {
    staticClass: "_bgcl-warning _dp-ilb _mg-4px"
  }, [_c('small', [_vm._v("_mg-4px")])])]), _vm._v(" "), _c('div', {
    staticClass: "_bgcl-neutral-300 _mgbt-4px"
  }, [_c('div', {
    staticClass: "_bgcl-warning _dp-ilb _mg-8px"
  }, [_c('small', [_vm._v("_mg-8px")])])]), _vm._v(" "), _c('div', {
    staticClass: "_bgcl-neutral-300 _mgbt-32px"
  }, [_c('div', {
    staticClass: "_bgcl-warning _dp-ilb _mg-16px"
  }, [_c('small', [_vm._v("_mg-16px")])])]), _vm._v(" "), _c('div', {
    staticClass: "_bgcl-neutral-300 _mgbt-4px"
  }, [_c('div', {
    staticClass: "_bgcl-warning _dp-ilb _mgl-1px"
  }, [_c('small', [_vm._v("_mgl-1px")])])]), _vm._v(" "), _c('div', {
    staticClass: "_bgcl-neutral-300 _mgbt-4px"
  }, [_c('div', {
    staticClass: "_bgcl-warning _dp-ilb _mgl-2px"
  }, [_c('small', [_vm._v("_mgl-2px")])])]), _vm._v(" "), _c('div', {
    staticClass: "_bgcl-neutral-300 _mgbt-4px"
  }, [_c('div', {
    staticClass: "_bgcl-warning _dp-ilb _mgl-4px"
  }, [_c('small', [_vm._v("_mgl-4px")])])]), _vm._v(" "), _c('div', {
    staticClass: "_bgcl-neutral-300 _mgbt-4px"
  }, [_c('div', {
    staticClass: "_bgcl-warning _dp-ilb _mgl-8px"
  }, [_c('small', [_vm._v("_mgl-8px")])])]), _vm._v(" "), _c('div', {
    staticClass: "_bgcl-neutral-300 _mgbt-32px"
  }, [_c('div', {
    staticClass: "_bgcl-warning _dp-ilb _mgl-16px"
  }, [_c('small', [_vm._v("_mgl-16px")])])]), _vm._v(" "), _c('div', {
    staticClass: "_bgcl-neutral-300 _mgbt-4px"
  }, [_c('div', {
    staticClass: "_bgcl-warning _dp-ilb _mgr-1px"
  }, [_c('small', [_vm._v("_mgr-1px")])]), _vm._v(" "), _c('div', {
    staticClass: "_bgcl-neutral-400 _dp-ilb"
  }, [_c('small', [_vm._v("Other Box")])])]), _vm._v(" "), _c('div', {
    staticClass: "_bgcl-neutral-300 _mgbt-4px"
  }, [_c('div', {
    staticClass: "_bgcl-warning _dp-ilb _mgr-2px"
  }, [_c('small', [_vm._v("_mgr-2px")])]), _vm._v(" "), _c('div', {
    staticClass: "_bgcl-neutral-400 _dp-ilb"
  }, [_c('small', [_vm._v("Other Box")])])]), _vm._v(" "), _c('div', {
    staticClass: "_bgcl-neutral-300 _mgbt-4px"
  }, [_c('div', {
    staticClass: "_bgcl-warning _dp-ilb _mgr-4px"
  }, [_c('small', [_vm._v("_mgr-4px")])]), _vm._v(" "), _c('div', {
    staticClass: "_bgcl-neutral-400 _dp-ilb"
  }, [_c('small', [_vm._v("Other Box")])])]), _vm._v(" "), _c('div', {
    staticClass: "_bgcl-neutral-300 _mgbt-4px"
  }, [_c('div', {
    staticClass: "_bgcl-warning _dp-ilb _mgr-8px"
  }, [_c('small', [_vm._v("_mgr-8px")])]), _vm._v(" "), _c('div', {
    staticClass: "_bgcl-neutral-400 _dp-ilb"
  }, [_c('small', [_vm._v("Other Box")])])]), _vm._v(" "), _c('div', {
    staticClass: "_bgcl-neutral-300 _mgbt-32px"
  }, [_c('div', {
    staticClass: "_bgcl-warning _dp-ilb _mgr-16px"
  }, [_c('small', [_vm._v("_mgr-16px")])]), _vm._v(" "), _c('div', {
    staticClass: "_bgcl-neutral-400 _dp-ilb"
  }, [_c('small', [_vm._v("Other Box")])])]), _vm._v(" "), _c('div', {
    staticClass: "_bgcl-neutral-300 _mgbt-4px"
  }, [_c('div', {
    staticClass: "_bgcl-warning _dp-ilb _mgv-1px"
  }, [_c('small', [_vm._v("_mgv-1px")])])]), _vm._v(" "), _c('div', {
    staticClass: "_bgcl-neutral-300 _mgbt-4px"
  }, [_c('div', {
    staticClass: "_bgcl-warning _dp-ilb _mgv-2px"
  }, [_c('small', [_vm._v("_mgv-2px")])])]), _vm._v(" "), _c('div', {
    staticClass: "_bgcl-neutral-300 _mgbt-4px"
  }, [_c('div', {
    staticClass: "_bgcl-warning _dp-ilb _mgv-4px"
  }, [_c('small', [_vm._v("_mgv-4px")])])]), _vm._v(" "), _c('div', {
    staticClass: "_bgcl-neutral-300 _mgbt-4px"
  }, [_c('div', {
    staticClass: "_bgcl-warning _dp-ilb _mgv-8px"
  }, [_c('small', [_vm._v("_mgv-8px")])])]), _vm._v(" "), _c('div', {
    staticClass: "_bgcl-neutral-300 _mgbt-32px"
  }, [_c('div', {
    staticClass: "_bgcl-warning _dp-ilb _mgv-16px"
  }, [_c('small', [_vm._v("_mgv-16px")])])]), _vm._v(" "), _c('div', {
    staticClass: "_bgcl-neutral-300 _mgbt-4px"
  }, [_c('div', {
    staticClass: "_bgcl-warning _dp-ilb _mgh-1px"
  }, [_c('small', [_vm._v("_mgh-1px")])]), _vm._v(" "), _c('div', {
    staticClass: "_bgcl-neutral-400 _dp-ilb"
  }, [_c('small', [_vm._v("Other Box")])])]), _vm._v(" "), _c('div', {
    staticClass: "_bgcl-neutral-300 _mgbt-4px"
  }, [_c('div', {
    staticClass: "_bgcl-warning _dp-ilb _mgh-2px"
  }, [_c('small', [_vm._v("_mgh-2px")])]), _vm._v(" "), _c('div', {
    staticClass: "_bgcl-neutral-400 _dp-ilb"
  }, [_c('small', [_vm._v("Other Box")])])]), _vm._v(" "), _c('div', {
    staticClass: "_bgcl-neutral-300 _mgbt-4px"
  }, [_c('div', {
    staticClass: "_bgcl-warning _dp-ilb _mgh-4px"
  }, [_c('small', [_vm._v("_mgh-4px")])]), _vm._v(" "), _c('div', {
    staticClass: "_bgcl-neutral-400 _dp-ilb"
  }, [_c('small', [_vm._v("Other Box")])])]), _vm._v(" "), _c('div', {
    staticClass: "_bgcl-neutral-300 _mgbt-4px"
  }, [_c('div', {
    staticClass: "_bgcl-warning _dp-ilb _mgh-8px"
  }, [_c('small', [_vm._v("_mgh-8px")])]), _vm._v(" "), _c('div', {
    staticClass: "_bgcl-neutral-400 _dp-ilb"
  }, [_c('small', [_vm._v("Other Box")])])]), _vm._v(" "), _c('div', {
    staticClass: "_bgcl-neutral-300 _mgbt-32px"
  }, [_c('div', {
    staticClass: "_bgcl-warning _dp-ilb _mgh-16px"
  }, [_c('small', [_vm._v("_mgh-16px")])]), _vm._v(" "), _c('div', {
    staticClass: "_bgcl-neutral-400 _dp-ilb"
  }, [_c('small', [_vm._v("Other Box")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-51bd1467","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/document-pages/AtomicMargin.vue
// module id = 130
// module chunks = 0